var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeshOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 17.5L1.66699 10L6.00033 2.5H14.667L17.0837 6.66667H15.0837L13.7087 4.16667H6.95866L3.58366 10L6.95866 15.8333H13.7087L15.132 13.3333H17.1708L14.667 17.5H6.00033Z",
    fill: "#77787F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7025 14.1537L15.1523 10.4105L11.7025 6.6665V9.53836H6.66699V11.3726H11.7025V14.1537Z",
    fill: "#77787F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeshOutIcon);
export default __webpack_public_path__ + "static/media/mesh_out_icon.018d2b5244804369afc277ccfe4f90c2.svg";
export { ForwardRef as ReactComponent };